import { gql } from '@apollo/client';
import { SubscriptionInfo } from '../fragments';

export default gql`
  query subscriptions($upcoming: Boolean) {
    subscriptions(upcoming: $upcoming) {
      ...SubscriptionInfo
    }
  }
  ${SubscriptionInfo}
`;
